module.exports = "query ($reference: ID!) {\n  Project(id: $reference) {\n    id\n    name\n  }\n}\n"